import React, { useState, useEffect } from "react";
import axios from "axios";
import appConstants from "../constants/appConstants";
import Layout from "../components/Layout";
import { useNavigate } from "react-router-dom";
import { Card } from "react-bootstrap";

const getAuthToken = () => localStorage.getItem("authToken");

const BatchSelection = () => {
  const [batches, setBatches] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchBatches();
  }, []);

  const fetchBatches = async () => {
    const token = getAuthToken();
    if (!token) {
      alert("Unauthorized! Please log in.");
      return;
    }
    try {
      const response = await axios.get(`${appConstants.API_ROOT_URL}get-batches`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setBatches(response.data.data);
    } catch (error) {
      console.error("Error fetching batches:", error);
    }
  };

  
  return (
    <Layout>
      <h3 className="mb-4">Select a Batch for Attendance</h3>
      <div className="row">
        {batches.map((batch) => (
          <div key={batch.id} className="col-md-4 mb-4">
            <Card
              className="text-center p-4 bg-dark text-white border-0 shadow rounded-4"
              onClick={() => navigate(`/attendance/${batch.id}`)}
              role="button"
              style={{ transition: '0.3s' }}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-3px)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              <Card.Body>
                <h4 className="fw-bold mb-2">{batch.class_name}</h4>
                <p className="fs-5 mb-0">{batch.division}</p>
              </Card.Body>
            </Card>
          </div>
        ))}
      </div>
    </Layout>
  );
  

};

export default BatchSelection;
